module.exports = __webpack_public_path__ + "static/img/card_icon_hdcz@2x.24b38c2d.png";